export const SET_DAYS = 'SET_DAYS'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const TESTDRIVE_SEARCH_TERM = 'TESTDRIVE_SEARCH_TERM'
export const TESTDRIVE_PAGE_SIZE = 'TESTDRIVE_PAGE_SIZE'
export const TESTDRIVE_SORT_DIR = 'TESTDRIVE_SORT_DIR'
export const TESTDRIVE_ORDER_BY = 'TESTDRIVE_ORDER_BY'
export const TESTDRIVE_FILTER_BY = 'TESTDRIVE_FILTER_BY'
export const SET_TESTDRIVETYPERATES = 'SET_TESTDRIVETYPERATES'
export const INIT_TESTDRIVE = 'INIT_TESTDRIVE'
export const INIT_TESTDRIVEDRIVE = 'INIT_TESTDRIVEDRIVE'
export const INIT_TESTDRIVEWAYPOINT = 'INIT_TESTDRIVEWAYPOINT'
export const SET_TESTDRIVE = 'SET_TESTDRIVE'
export const SET_TESTDRIVES = 'SET_TESTDRIVES'
export const UPDATE_TESTDRIVE = 'UPDATE_TESTDRIVE'
export const SET_TESTDRIVEDRIVES = 'SET_TESTDRIVEDRIVES'
export const SET_TESTDRIVEDRIVE = 'SET_TESTDRIVEDRIVE'
export const UPDATE_TESTDRIVEDRIVE = 'UPDATE_TESTDRIVEDRIVE'
export const SET_TESTDRIVEWAYPOINTS = 'SET_TESTDRIVEWAYPOINTS'
export const SET_TESTDRIVEWAYPOINT = 'SET_TESTDRIVEWAYPOINT'
export const UPDATE_TESTDRIVEWAYPOINT = 'UPDATE_TESTDRIVEWAYPOINT'
export const SET_VIDEO_URL = 'SET_VIDEO_URL'
export const SET_WEATHER = 'SET_WEATHER'
export const SET_VIDEOLINK = 'SET_VIDEOLINK'
export const SET_TESTDRIVERESULTS = 'SET_TESTDRIVERESULTS'
export const SET_REPORTPREFERENCE = 'SET_REPORTPREFERENCE'



// WEBPACK FOOTER //
// ./src/store/modules/testdrives/types.js